import React from 'react';

const ProductCopyRight = () => {
  return (
    <div className="my-12">
      <div className="max-w-[71.5rem] mx-4 lg:w-[96%] lg:mx-auto">
        <div className="text-[0.75rem] flex flex-col gap-3 text-gray-500">
          <p>*Full version of game required to use DLC. Sold separately.</p>
          <p>
            **Additional games and systems required for multiplayer mode. Sold
            separately.
          </p>
          <p>
            ***Nintendo Switch Online membership (sold separately) and Nintendo
            Account required for online features. A paid Nintendo Switch Online
            + Expansion Pass membership is required for free access to Splatoon
            2: Octo Expansion DLC. Not available in all countries. Internet
            access required for online features. Terms apply.
            nintendo.com/switch-online
          </p>
          <p>
            This version of Splatoon 2: Octo Expansion is only compatible with
            the version of Splatoon 2 for the Americas. To confirm which
            region(s) your game is compatible with, please open the game's
            Options in the HOME Menu and select "Support Information." For
            additional help, please visit support.nintendo.com.
          </p>
          <p>
            © 2017 Nintendo. Splatoon and Nintendo Switch are trademarks of
            Nintendo. © Nintendo.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProductCopyRight;
